<template>
 <div :style="{color}" class="line-item mx-4" style="white-space:nowrap;width:min-content"> 
      {{item.date | formatDate("DD/MM/YYYY HH:mm:ss")}} | {{item.debugType}} | {{item.misId}} | {{item.cycle}} | {{JSON.stringify(item.data)}}      
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { DebugItem } from '@/models/ui/DebugItem';
import { DebugType } from '../../../enum/DebugType';
import { WobBase } from '../../../models/wob/WobBase';
import { WobType } from '../../../enum/WobType';


@Component({
  name: 'DebugListLine',   
   props: {  
     item:{
       type:DebugItem,
       required:true
     }
  }
})
export default class DebugListLine extends Vue {
  item!:DebugItem  
  get color() {
    switch(this.item.debugType){
      case DebugType.WOB:        
        const wob = this.item.data as WobBase
        switch(wob.wobType){
          case WobType.WobGliderIrisGdb:
          case WobType.WobIrisGdb: return '#633974' //violet
          case WobType.WobGliderGdb:          
          case WobType.WobGliderStatus:
          case WobType.WobGliderHang:
          case WobType.WobGliderAlarm:
          case WobType.WobGliderNav:   return "#2E86C1" //bleu        
          case WobType.WobGliderModConf: return "#B03A2E" //rouge
          case WobType.WobGliderFile: return "#F1C40F"  //jaune
          case WobType.WobAdminChanged: return "#229954"  //vert
          case WobType.WobDatapoolChanged: return "#D35400" //Orange
          default: return "#616A6B" //Gris
        }          
      default: return "#000000"  // noir
    }    
  }
}
</script>

<style>
  
</style>